import { render, staticRenderFns } from "./PaymentOption.vue?vue&type=template&id=56021ca3&scoped=true&"
import script from "./PaymentOption.vue?vue&type=script&lang=js&"
export * from "./PaymentOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56021ca3",
  null
  
)

export default component.exports